import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Acaricidas microbiologicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function AcaricidasMicroBio(props) {
  useEffect(() => {
    const title = 'acaricidaMicroBio.acaricidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.ACARICIDA_MICROBIOLOGICO}
      insumoURL='acaricidas-microbiologicos'
      viewKey='acaricidasMicroBio'
      deleteMessageSucess={formatMessage(
        'acaricidaMicroBio.acaricidaMicroBioRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('acaricidaMicroBio.falhaAoExcluirAcaricidaMicroBio')}
      mensagemDelete={formatMessage('acaricidaMicroBio.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'acaricidasMicroBio';
  })[0].content
});

export default connect(mapStateToProps)(AcaricidasMicroBio);
